import Nav from "@/views/crm/marketing/whatsapp-broadcast/extension/_nav.vue";
import ExtensionIndex from "@/views/crm/marketing/whatsapp-broadcast/extension/index.vue";
import ExtensionList from "@/views/crm/marketing/whatsapp-broadcast/extension/list.vue";
import ExtensionItem from "@/views/crm/marketing/whatsapp-broadcast/extension/item.vue";
import ExtensionAnalytics from "@/views/crm/marketing/whatsapp-broadcast/extension/analytics.vue";
import Contacts from "@/views/crm/marketing/whatsapp-broadcast/Contacts.vue";
import store from "@/store";

export default [
  {
    path: "whatsapp-broadcasts/ext",
    component: ExtensionIndex,
    beforeEnter: (to, from, next) => {
      const isExtensionBroadcastAvailable =
        store.getters["biz/isExtensionBroadcastAvailable"];
      if (!isExtensionBroadcastAvailable) {
        next({ name: "home" });
        return;
      }
      next();
    },
    children: [
      {
        path: "",
        name: "whatsapp-extension-broadcasts",
        component: ExtensionList,
        meta: {
          label: "broadcasts",
          breadcrumbs: ["home", "whatsapp-extension-broadcasts"],
        },
      },
      {
        path: ":id",
        component: Nav,
        props: true,
        children: [
          {
            path: "",
            name: "whatsapp-extension-broadcast",
            component: ExtensionItem,
            props: true,
            meta: {
              label: "Broadcast",
              breadcrumbs: [
                "home",
                "whatsapp-extension-broadcasts",
                "whatsapp-extension-broadcast",
              ],
            },
          },
          {
            path: "analytics",
            name: "whatsapp-extension-broadcast-analytics",
            component: ExtensionAnalytics,
            props: true,
            meta: {
              label: "Analytics",
              breadcrumbs: [
                "home",
                "whatsapp-extension-broadcasts",
                "whatsapp-extension-broadcast",
                "whatsapp-extension-broadcast-analytics",
              ],
            },
          },
          {
            path: "contacts",
            name: "whatsapp-extension-broadcast-contacts",
            component: Contacts,
            props: true,
            meta: {
              label: "Contacts",
              breadcrumbs: [
                "home",
                "whatsapp-extension-broadcasts",
                "whatsapp-extension-broadcast",
                "whatsapp-extension-broadcast-contacts",
              ],
            },
          },
        ],
      },
    ],
  },
];
